'use strict';

angular.module('app.notificationLogin')
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider          
            .state('landing.notificationLogin', {
                url: '/notification/notificationLogin/:hashedPassword/:path/:isurl',
                templateUrl: 'app/home/partials/login.html?app_v=deployDate',
                scope: {},
                data: {
                    authorizedRoles: []
                 },
                controller: 'notificationLoginCtrl',
                params: {
                    hashedPassword: null,
                    path: null,
                    isurl: null,
                }
            })  
    }]);